import { Rect } from "../.././MyHelpers";
import { ScreenProtocolMessage } from "../../ScreenProtocol";
import { IBonusStartConfig } from "../SlotGame";
import { PickBonusReward } from "./PickBonusParams";
import { PickBonusSession } from "./PickBonusSession";

export namespace PickBonusMessages {
	

	export class PrepareMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "prepare";
		public session: PickBonusSession = null;
		public startConfig: IBonusStartConfig = null;

		constructor(session: PickBonusSession, startConfig: IBonusStartConfig) {
			super(PrepareMessage.msgname);
			this.session = session;
			this.startConfig = startConfig;
		}
	}

	export class PickMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "pick";
		public session: PickBonusSession = null;

		constructor(session: PickBonusSession) {
			super(PickMessage.msgname);
			this.session = session;
		}
	}


	export class IntroMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "intro";
		public session: PickBonusSession = null;

		constructor(session: PickBonusSession) {
			super(IntroMessage.msgname);
			this.session = session;
		}
	}

	export class AwardMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "award";
		public pick: Rect = null;
		public award:PickBonusReward = null;

		constructor(pick: Rect, award:PickBonusReward ) {
			super(AwardMessage.msgname);
			this.pick = pick;
			this.award= award;
		}
	}

	export class CommetPickComplete extends ScreenProtocolMessage
	{
		public static readonly msgname = "comet";
		/* public pick: PixelRect = null;
		public award:PickBonusPick = null; */

		constructor() {
			super(CommetPickComplete.msgname);
			/* this.pick = pick;
			this.award= award; */
		} 
	}

	export class CommetJPComplete extends ScreenProtocolMessage
	{
		public static readonly msgname = "cometJp";
		/* public pick: PixelRect = null;
		public award:PickBonusPick = null; */

		constructor() {
			super(CommetJPComplete.msgname);
			/* this.pick = pick;
			this.award= award; */
		} 
	}
	export class CommetDestination extends ScreenProtocolMessage
	{
		public static readonly msgname = "commetDestination";
		public destRect: Rect = null;
		/*public award:PickBonusPick = null; */

		constructor(destRect: Rect) {
			super(CommetDestination.msgname);
			this.destRect = destRect;
			/*this.award= award; */
		} 
	}

	export class CommetJp extends ScreenProtocolMessage
	{
		public static readonly msgname = "commetDestinationJP";
		public destRect: Rect = null;
		public srcRect: Rect = null;

		constructor(srcRect: Rect, destRect: Rect) {
			super(CommetJp.msgname);
			this.srcRect = srcRect;
			this.destRect = destRect;
			/*this.award= award; */
		} 
	}

	export class DiamondAnimation extends ScreenProtocolMessage
	{
		public static readonly msgname = "DiamondAnimationJPDisplay";
		//public destRect: PixelRect = null;
		//public srcRect: PixelRect = null;
		public hitJp:number = 0;

		constructor(/* srcRect: PixelRect,  destRect: PixelRect,*/ hitJp:number) {
			super(DiamondAnimation.msgname);
			//this.srcRect = srcRect;
			//this.destRect = destRect;
			this.hitJp = hitJp;
			/*this.award= award; */
		} 
	}

	

	export class JpShowFinish extends ScreenProtocolMessage
	{
		public static readonly msgname = "JpShowFinish";
		//public destRect: PixelRect = null;
		//public srcRect: PixelRect = null;
		//public hitJp:number = 0;

		constructor(/* srcRect: PixelRect,  destRect: PixelRect, hitJp:number*/) {
			super(JpShowFinish.msgname);
			//this.srcRect = srcRect;
			//this.destRect = destRect;
			//this.hitJp = hitJp;
			/*this.award= award; */
		} 
	}
	
}